module.exports = __webpack_public_path__ + "media/img/clients-modal/talendo-5c062a6fd9f25a70b205eb5230938287.svg";